import { useQuery, QueryConfig } from "react-query";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { onError } from "src/Helpers";

export const fetcher = async (
  url: string,
  headers: AxiosRequestConfig["headers"],
  config: AxiosRequestConfig
) => {
  const userString = localStorage.getItem("user");
  const user = JSON.parse(userString ?? '{}');
  const idToken = localStorage.getItem(user.keyPrefix + '.' + user.username + '.idToken');
  return await axios.request({
    baseURL: "",
    url,
    ...config,
    headers: {
      ...config?.headers,
      ...headers,
      'X-COG-ID': idToken,
    },
  });
};

function useApiFetch(
  queryKeys: [string, AxiosRequestConfig["headers"]?, AxiosRequestConfig?],
  queryConfig?: QueryConfig<AxiosResponse<any>, unknown> | undefined
) {
  return useQuery(queryKeys, fetcher, {
    onError,
    ...queryConfig,
  });
}

export default useApiFetch;

// Usage

// const {data, status, error} = useApiFetch(['/users?page=2']);

// console.log(data);
// console.log(status);
// console.log(error);
